// do not remove or any other imports
import('./react-entrypoint')